import React, { useState } from "react";
import CalculatorPage from "./CalculatorPage";

function CurrencyConverter() {
  const [amount, setAmount] = useState("");
  const [rate, setRate] = useState("");
  const [converted, setConverted] = useState(null);
  const [error, setError] = useState("");
  const [funFact, setFunFact] = useState("");
  const [showFunFact, setShowFunFact] = useState(false);

  const onInput = (setter) => (e) => {
    setter(e.target.value);
    setConverted(null);
    setShowFunFact(false);
    setError("");
  };

  const convertCurrency = () => {
    const a = parseFloat(amount);
    const r = parseFloat(rate);
    if (isNaN(a) || isNaN(r) || r <= 0) {
      setError("Please enter an amount and a positive exchange rate.");
      setConverted(null);
      setShowFunFact(false);
      return;
    }

    setError("");
    setConverted((a * r).toFixed(2));

    const funFactsList = [
      "The most traded currency in the world is the US Dollar.",
      "The Euro is used by 20 countries in the European Union.",
      "Currency exchange rates can change multiple times a day.",
      "The oldest currency still in use is the British Pound.",
      "Cryptocurrencies are also traded like traditional currencies.",
    ];

    setFunFact(funFactsList[Math.floor(Math.random() * funFactsList.length)]);
    setShowFunFact(true);
  };

  return (
    <CalculatorPage
      title="Currency Converter"
      metaDescription="Free currency converter: enter an amount and an exchange rate to convert between any two currencies instantly."
      intro={
        <>
          Convert between currencies using an <strong>exchange rate</strong>{" "}
          you provide — works for any currency pair.
        </>
      }
      seoContent={
        <>
          <h2>How to use this converter</h2>
          <p>
            Look up the current exchange rate for your currency pair (for
            example, 1 USD = 0.92 EUR), enter the amount you want to convert
            and the rate, and the converter multiplies them. Because you
            supply the rate yourself, it works for any pair — including rates
            your bank or exchange office actually offers, which are usually
            less favorable than the mid-market rate you see in the news.
          </p>
          <h2>Why converted amounts differ from the news rate</h2>
          <p>
            Banks and currency exchanges add a margin (typically 1–5%) on top
            of the mid-market rate, and may charge a fixed fee as well. For an
            accurate picture of what you'll receive, enter the rate you were
            actually quoted rather than the headline rate.
          </p>
          <h2>Frequently asked questions</h2>
          <h3>Why do I have to enter the exchange rate myself?</h3>
          <p>
            The converter runs entirely in your browser and doesn't call a live
            rates service, so you stay in control and can use the exact rate
            you've been quoted. Look up the current rate for your pair, type it
            in, and the tool does the multiplication.
          </p>
          <h3>Why is the bank's rate worse than the one online?</h3>
          <p>
            The rate in the news is the mid-market rate. Banks and exchanges
            add a margin — often 1–5% — and sometimes a fixed fee, so the rate
            you actually get is less favourable. Enter your quoted rate for a
            realistic result.
          </p>
          <h3>Can I use it for any currency pair?</h3>
          <p>
            Yes. Because you supply the rate, the converter works for any two
            currencies, including less common ones that live rate tools may not
            cover.
          </p>
        </>
      }
    >
      <div className="fields">
        <label className="field">
          <span>Amount</span>
          <input type="number" value={amount} onChange={onInput(setAmount)} placeholder="e.g. 100" />
        </label>
        <label className="field">
          <span>Exchange Rate</span>
          <input type="number" value={rate} onChange={onInput(setRate)} placeholder="e.g. 0.92" />
        </label>
      </div>

      <button className="btn" onClick={convertCurrency}>Convert</button>

      {error && <div className="error">{error}</div>}

      {converted && (
        <>
          <div className="result">
            Converted Amount: <strong>{Number(converted).toLocaleString()}</strong>
          </div>
          {showFunFact && (
            <div className="fun-fact fun-fact-animate">💡 {funFact}</div>
          )}
        </>
      )}
    </CalculatorPage>
  );
}

export default CurrencyConverter;
